import React from 'react';



const TimePeriodSelector = ({ selectedPeriod, onChange }) => {
  const periods = [
    { value: 'q1-2026', label: 'Q1 2026', range: 'Jan - Mar 2026' },
    { value: 'q4-2025', label: 'Q4 2025', range: 'Oct - Dec 2025' },
    { value: 'q3-2025', label: 'Q3 2025', range: 'Jul - Sep 2025' },
    { value: 'q2-2025', label: 'Q2 2025', range: 'Apr - Jun 2025' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full">
      <h3 className="font-heading font-semibold text-sm md:text-base text-foreground mb-3 md:mb-4 break-words">Time Period</h3>
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-2">
        {periods?.map((period) => (
          <button
            key={period?.value}
            onClick={() => onChange(period?.value)}
            className={`
              flex flex-col items-start p-2.5 md:p-3 rounded-md border transition-smooth
              ${selectedPeriod === period?.value
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-background text-foreground border-border hover:bg-muted'
              }
            `}
          >
            <span className="font-body font-medium text-xs md:text-sm break-words w-full">{period?.label}</span>
            <span className="caption text-[10px] md:text-xs opacity-80 break-words w-full">{period?.range}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimePeriodSelector;